import randomstring from "randomstring"
import { env, tidBaseUrl, tidClientId } from "./config/environments"

export interface ConfigTID {
  queryString: string
  redirect_uri: string
  code_verifier: string
  client_id: string | undefined
  url: string
  tokenEndpoint: string
  signUpQuery: string
  env: string
}

let _cached: ConfigTID | null = null

const getConfigTID = (): ConfigTID => {
  if (_cached) return _cached

  const code_verifier = randomstring.generate(128)

  const client_id = tidClientId
  const url = `${tidBaseUrl}/oauth/token`
  const tokenEndpoint = "/api/auth/token"
  const baseUrl = tidBaseUrl

  const redirect_uri =
    env === "prod"
      ? `https://mxp-api.trimble.com/tid/prod/redirect`
      : `https://mxp-api-stage.netlify.app/tid/${env}/redirect`

  const scope =
    env === "prod"
     ? "trimble-mxp-login%20openid%20iam%20TCMiddleware%20DX-Trials-App%20agents%20models"
      : env === "sit" || env === "uat"
      ? "MXP_Demo%20openid%20iam"
        : "MXP_Demo%20openid%20TCMiddleware-SIT%20DX-Trials%20iam%20agents%20models"

  const queryString = `${baseUrl}/oauth/authorize?scope=${scope}&response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}&state=`
  const signUpQuery = `${baseUrl}/oauth/authorize?scope=${scope}&response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}&prompt=create&state=`

  _cached = {
    queryString,
    redirect_uri,
    code_verifier,
    client_id,
    url,
    tokenEndpoint,
    signUpQuery,
    env,
  }
  return _cached
}

export default getConfigTID